import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "leaflet/dist/leaflet.css";
import { initErrorReporting } from "./utils/errorReporting";
import { startAccount } from "./firebase/account";

/* Before render, so an error while mounting is still reported. */
initErrorReporting();

/* Follows sign-in, and points My Study at the reader's account while they
   are signed in. Does nothing, and downloads nothing, while accounts are not
   configured. */
startAccount();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Router>
    <App />
  </Router>
);